<template>
  <div>
    <form >
      <div class="form-group">
        <label for="from_extra" v-translate>Street and number</label>
        <div class="input-group">
          <address-autocomplete ref="addressAutocomplete" @selected="selectedItem" :minCharacter="4" :required="true" />
        </div>
      </div>
      <div v-if="this.theCheckedAddress.id">
        <p>
          <font-awesome-icon size="1x" icon="map-marker" color="red" /> {{theCheckedAddress.formatted_address}}<br>
          <font-awesome-icon size="1x" icon="crosshairs" color="dark" />
          <span v-translate="{data: theCheckedAddress.id}">Moova Place ID: <strong>%{data}</strong></span>
        </p>
        <h2>
          <translate>In area?</translate>
          <span v-if="this.theCheckedAddress.in_area" class="text-success" v-translate>YES</span>
          <span v-else class="text-danger" v-translate>NO</span>
        </h2>
        <div v-if="theCheckedArea.id"><hr>
          <span v-translate="{data: theCheckedArea.id}">ID: <strong>%{data}</strong></span><br>
          <span v-translate="{data: theCheckedArea.name}">Name: <strong>%{data}</strong></span><br>
          <translate>Is Dangerous?</translate>
          <strong v-if="theCheckedArea.is_dangerous" class="text-danger" v-translate>YES</strong>
          <strong v-else v-translate>NO</strong>
        </div>
      </div>
      <div v-else-if="theCheckedAddress && theCheckedAddress.validAddress === false">
        <h3 class="text-danger" v-translate>Invalid address or address not found</h3>
        <hr v-if="theCheckedAddress.formatted_address">
        <p v-if="theCheckedAddress.formatted_address" v-translate="{data: theCheckedAddress.formatted_address}">Geo Services takes it as: <strong>%{data}</strong> </p>
      </div>
    </form>
  </div>
</template>

<script>
import AddressMixins from '@/mixins/address.mixin.js'
import AddressAutocomplete from '@/components/autocompletes/AddressAutocomplete'
export default {
  name: 'InAreaCheck',
  components: {
    AddressAutocomplete
  },
  data() {
    return {
      ignoreArea: true,
      theCheckedArea: {}
    }
  },
  mixins: [AddressMixins],
  methods: {
    async selectedItem(item) {
      this.theCheckedArea = {}
      this.theCheckedAddress = {}
      await this.checkPlace(item)
      this.$nextTick(() => {
        if (this.theCheckedAddress.id) {
          if (this.theCheckedAddress.in_area) {
            this.$http.get(this.$appConfig.api.baseUrl + 'areas/' + this.theCheckedAddress.in_area.id)
              .then(response => {
                this.theCheckedArea = response.body
              })
          }
        }
      })
    }
  }
}
</script>
